import React from 'react';
import MyPlan from '@/pages/Products/VpsOciDetailPage/MyPlan/MyPlan.jsx';
import * as Styles from './VpsStoreLoaderPage.styles';
import LoaderPage from '@/pages/Loader/LoaderPage';

const VpsStoreLoaderPage = ({
  progress = null,
  isLoaderBuilder,
  title,
  description,
}) => (
  <Styles.Container data-testid="vpsoci-templates-page-loader">
    <MyPlan />
    <Styles.WrapperLoaderPage data-testid="vps-store-loader-page-wrapper">
      <LoaderPage
        progress={progress}
        title={title}
        description={description}
        borderRadius="16px"
        isLoaderBuilder={isLoaderBuilder}
      />
    </Styles.WrapperLoaderPage>
  </Styles.Container>
);

export default VpsStoreLoaderPage;
